export const FETCH_APP_LOGS_START = "FETCH_APP_LOGS_START";
export const FETCH_APP_LOGS_SUCCESS = "FETCH_APP_LOGS_SUCCESS";
export const FETCH_APP_LOGS_FAILURE = "FETCH_APP_LOGS_FAILURE";
export const FETCH_CFR_LOGS_URL_START = "FETCH_CFR_LOGS_URL_START";
export const FETCH_CFR_LOGS_URL_SUCCESS = "FETCH_CFR_LOGS_URL_SUCCESS";
export const FETCH_CFR_LOGS_URL_FAILURE = "FETCH_CFR_LOGS_URL_FAILURE";
